module.exports = __webpack_public_path__ + "img/energy_fenxiyuce.a4c07666.png";